var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#C2DFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 27.1667H27.7499C26.9764 27.1667 26.2345 26.8594 25.6875 26.3124C25.1405 25.7654 24.8333 25.0236 24.8333 24.25C24.8333 23.4765 25.1405 22.7346 25.6875 22.1876C26.2345 21.6406 26.9764 21.3333 27.7499 21.3333C31.8333 21.3333 32.9999 27.1667 32.9999 27.1667ZM32.9999 27.1667H38.2499C39.0235 27.1667 39.7653 26.8594 40.3123 26.3124C40.8593 25.7654 41.1666 25.0236 41.1666 24.25C41.1666 23.4765 40.8593 22.7346 40.3123 22.1876C39.7653 21.6406 39.0235 21.3333 38.2499 21.3333C34.1666 21.3333 32.9999 27.1667 32.9999 27.1667ZM32.9999 27.1667L32.9999 44.6667M21.3333 35.3333H44.6666M21.3333 30.9L21.3333 40.9333C21.3333 42.2401 21.3333 42.8935 21.5876 43.3926C21.8113 43.8317 22.1682 44.1886 22.6073 44.4123C23.1064 44.6667 23.7598 44.6667 25.0666 44.6667L40.9333 44.6667C42.24 44.6667 42.8934 44.6667 43.3926 44.4124C43.8316 44.1886 44.1886 43.8317 44.4123 43.3926C44.6666 42.8935 44.6666 42.2401 44.6666 40.9333V30.9C44.6666 29.5932 44.6666 28.9398 44.4123 28.4407C44.1886 28.0016 43.8316 27.6447 43.3926 27.421C42.8934 27.1667 42.24 27.1667 40.9333 27.1667L25.0666 27.1667C23.7598 27.1667 23.1064 27.1667 22.6073 27.421C22.1682 27.6447 21.8113 28.0016 21.5876 28.4407C21.3333 28.9398 21.3333 29.5932 21.3333 30.9Z",
    stroke: "#2264AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D9EBFF",
    strokeWidth: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.e82f86d78bdcb42ff7a3d628f5dd7f71.svg";
export { ForwardRef as ReactComponent };